const { $ } = window
const $body = $(document.body)

export default {
	init() {
      $('.tabs-list__item').on('click', function(e) {
         document.getElementsByClassName("board-of-directors-wrap")[0].scrollIntoView({
            behavior: 'smooth'
         });
      })
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
}